import * as React from 'react';
import {
  Grid,
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import type { IStoreDetails } from './StoreInterfaces';

interface IStoreDetailsProps {
  formValues: IStoreDetails,
  setFormValues: (values: IStoreDetails) => void,
}

const StoreDetails: React.FC<IStoreDetailsProps> = ({
  formValues, setFormValues,
}) => (
  <>
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Box p={1}>
          <Typography variant="h6">
            {'Contact Information'}
          </Typography>
        </Box>
        <Box p={1}>
          <TextField
            value=""
            id="contactName-value-input"
            disabled
            label="Name"
            variant="outlined"
            type="string"
            fullWidth
          />
        </Box>
        <Box p={1}>
          <TextField
            value={formValues.email}
            id="email-value-input"
            label="Email"
            variant="outlined"
            type="string"
            fullWidth
            onChange={(event) => {
              const inputVal = event.target.value;
              const tempFormValues: IStoreDetails = { ...formValues, email: inputVal };
              setFormValues(tempFormValues);
            }}
          />
        </Box>
        <Box p={1}>
          <TextField
            id="phone-value-input"
            disabled
            label="Phone"
            variant="outlined"
            type="string"
            fullWidth
          />
        </Box>
        <Box p={1}>
          <TextField
            id="title-value-input"
            disabled
            label="Title"
            variant="outlined"
            type="string"
            fullWidth
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box padding={1}>
          <Typography variant="h6">
            {'Office Address'}
          </Typography>
        </Box>
        <Box p={1}>
          <TextField
            value={formValues.address1}
            id="address1-value-input"
            required
            label="Address 1"
            variant="outlined"
            type="string"
            fullWidth
            onChange={(event) => {
              const inputVal = event.target.value;
              const tempFormValues: IStoreDetails = { ...formValues, address1: inputVal };
              setFormValues(tempFormValues);
            }}
          />
        </Box>
        <Box p={1}>
          <TextField
            id="address2-value-input"
            label="Address 2"
            variant="outlined"
            type="string"
            fullWidth
          />
        </Box>
        <Box p={1}>
          <TextField
            value={formValues.city}
            id="city-value-input"
            required
            label="City"
            variant="outlined"
            type="string"
            fullWidth
            onChange={(event) => {
              const inputVal = event.target.value;
              const tempFormValues: IStoreDetails = { ...formValues, city: inputVal };
              setFormValues(tempFormValues);
            }}
          />
        </Box>
        <Box p={1}>
          <TextField
            value={formValues.state}
            id="state-value-input"
            required
            label="State"
            variant="outlined"
            type="string"
            fullWidth
            onChange={(event) => {
              const inputVal = event.target.value;
              const tempFormValues: IStoreDetails = { ...formValues, state: inputVal };
              setFormValues(tempFormValues);
            }}
          />
        </Box>
        <Box p={1}>
          <TextField
            value={formValues.zipCode}
            id="zipCode-value-input"
            required
            label="Zip Code"
            variant="outlined"
            type="string"
            fullWidth
            onChange={(event) => {
              const inputVal = event.target.value;
              const tempFormValues: IStoreDetails = { ...formValues, zipCode: inputVal };
              setFormValues(tempFormValues);
            }}
          />
        </Box>
        <Box p={1}>
          <FormControlLabel
            disabled
            label="Billing Address same as Office Address"
            control={(
              <Checkbox color="primary" size="small" id="billing-same-as-office-radio-button" />
            )}
          />
        </Box>
      </Grid>
    </Grid>
  </>
);

export default StoreDetails;
